import React, { useEffect, useState } from "react";
import Modal from "../../Layout/Modal";

const ModalImageHighlight = ({
  modalId4,
  onCloseModal4,
  filesDescsNew,
  fileSelectedNew,
  media_types,
  content_types,
  onAddFileDescModal,
  onDescChange,
}) => {
  return (
    <Modal
      id={modalId4}
      title="Image Description"
      onClose={onCloseModal4}
      modalSize="modal-lg"
    >
      <div className="col-md-12">
        <div className="form-group">
          <label htmlFor="file_name">Image Name</label>
          {fileSelectedNew && (
            <input
              name="file_name"
              value={
                (fileSelectedNew.fileName = "" ? "" : fileSelectedNew.fileName)
              }
              className="form-control"
              disabled={true}
            />
          )}
        </div>
      </div>

      <div className="col-md-12">
        {fileSelectedNew && filesDescsNew ? (
          <div className="form-group">
            <label htmlFor="description">Image Description</label>
            {filesDescsNew[fileSelectedNew.fileName] ? (
              <input
                type="text"
                name="description"
                value={filesDescsNew[fileSelectedNew.fileName].media_desc}
                onChange={onDescChange}
                className="form-control"
              />
            ) : (
              <input
                type="text"
                name="description"
                value=""
                onChange={onDescChange}
                className="form-control"
              />
            )}
          </div>
        ) : (
          <div className="form-group">
            <label htmlFor="description">Image Description</label>
            <input
              type="text"
              name="description"
              value=""
              onChange={onDescChange}
              className="form-control"
            />
          </div>
        )}
      </div>

      <div className="row">
        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="media_types">Image Type</label>
            {media_types.length > 0 &&
              media_types.map((item) => (
                <div
                  key={item.code}
                  onClick={() =>
                    onAddFileDescModal(
                      item.code,
                      "media_types",
                      fileSelectedNew
                    )
                  }
                  className={
                    fileSelectedNew &&
                    filesDescsNew &&
                    filesDescsNew[fileSelectedNew.fileName] &&
                    filesDescsNew[fileSelectedNew.fileName].media_types.indexOf(
                      item.code
                    ) > -1
                      ? "bg-orange"
                      : "bg-white"
                  }
                  style={{
                    border: "1px solid #ccc",
                    marginBottom: 5,
                    padding: 5,
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                >
                  {item.name}
                </div>
              ))}
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group">
            <label htmlFor="content_types">Content Type</label>
            {content_types.length > 0 &&
              content_types.map((item) => (
                <div
                  key={item.code}
                  onClick={() => onAddFileDescModal(item.code, "content_types")}
                  className={
                    fileSelectedNew &&
                    filesDescsNew &&
                    filesDescsNew[fileSelectedNew.fileName] &&
                    filesDescsNew[
                      fileSelectedNew.fileName
                    ].content_types.indexOf(item.code) > -1
                      ? "bg-orange"
                      : "bg-white"
                  }
                  style={{
                    border: "1px solid #ccc",
                    marginBottom: 5,
                    padding: 5,
                    borderRadius: 5,
                    cursor: "pointer",
                  }}
                >
                  {item.name}
                </div>
              ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ModalImageHighlight;
